import React, { useState } from "react";
import { SetupDataPageTemplate } from "../../../components/setup-pages/SetupDataPageTemplate";
import { Field, Form } from "react-jsonschema-form-validation";
import { setupData } from "../../../configs/routes";
import {
	resetUserSettings,
	saveYourControl,
} from "../../../services/userService";
import { saveAutoLogin, loadAutoLogin } from "../../../services/authService";
import { schema } from "../YourControl";
import { getDateFromEpoch } from "../../../services/dateService";
import * as dateFns from "date-fns";

import { pathRoot } from "../YourControl";

export function Page1({ yourControlSettings, companionStartDate, ...props }) {
	// -- Required for Day of Week selector
	// const [dayOfWeek, setDayOfWeek] = useState(yourControlSettings.dayOfWeek ?? null);
	const [startDate] = useState(
		getDateFromEpoch(parseInt(companionStartDate, 10))
	);
	const [autoLogin, setAutoLogin] = useState(loadAutoLogin());

	const onNext = () => {
		// -- Required for 'Day of Week' selection
		// yourControlSettings.dayOfWeek = dayOfWeek;

		yourControlSettings.autoLogin = autoLogin;
		saveAutoLogin(autoLogin);

		return new Promise((resolve) => {
			yourControlSettings.complete = true;

			saveYourControl(yourControlSettings)
				.then(resolve)
				.catch((error) => {
					if (props.onSaveFailure) {
						props.onSaveFailure(error);
					}
					resolve();
				});
		});
	};

	const hideNext = () => {
		return autoLogin === null;
	};

	const headerDetails = {
		title: "Your Control",
		currentPage: 1,
		pageCount: 3,
	};

	return (
		<>
			<SetupDataPageTemplate
				headerDetails={headerDetails}
				backTo={setupData}
				nextTo={`${pathRoot}/2`}
				onClickBack={resetUserSettings}
				onClickNext={{ async: true, func: onNext }}
				// nextTextOverride={"Finish"}
				hideNext={hideNext()}
			>
				<Form schema={schema}>
					{startDate ? (
						<div className="divide-y divide-white divide-opacity-30">
							<div className="py-2">
								<p
									className={
										"mb-4 sm:mb-6 text-sm lg:text-base leading-tight lg:leading-6"
									}
								>
									You started using Your Health Companion on{" "}
									<b>{dateFns.format(startDate, "do MMM yyyy")}</b>
								</p>
							</div>
						</div>
					) : null}

					<h2 className={"text-lg sm:text-xl font-bold mb-1 sm:mb-2"}>
						Do you wish to stay logged in?
					</h2>
					<div className={"flex"}>
						<div className={"flex-grow"}>
							<p
								className={
									"mb-4 text-sm lg:text-base leading-tight lg:leading-6 pr-2"
								}
							>
								If you choose <b>No</b> you will need to log in using your
								username and password each time you use the App on this device.
								This is the secure option and is preferred if you share this
								device with other people.
							</p>
							<p
								className={
									"mb-4 text-sm lg:text-base leading-tight lg:leading-6 pr-2"
								}
							>
								If you choose <b>Yes</b> you will not need to enter your
								username or password again on this device until you select{" "}
								<b>No</b> or you have not used the App for 2 months.
							</p>
						</div>
					</div>

					<div className={"w-56 mb-8"}>
						<div className={`radioSlider`}>
							<Field
								type="radio"
								name="autoLogin"
								id="autoLoginNo"
								className={"hidden radioOption"}
								value={"autoLoginNo"}
								checked={autoLogin === false}
								onClick={() => setAutoLogin(false)}
							/>
							<label
								htmlFor={"autoLoginNo"}
								className={`option ${
									!autoLogin ? `bg-black text-white font-medium` : "bg-gray-100"
								}`}
							>
								No
							</label>

							<Field
								type="radio"
								name="autoLogin"
								id="autoLoginYes"
								className={"hidden radioOption"}
								value={"autoLoginYes"}
								checked={autoLogin === true}
								onClick={() => setAutoLogin(true)}
							/>
							<label
								htmlFor={"autoLoginYes"}
								className={`option ${
									autoLogin ? `bg-black text-white font-medium` : "bg-gray-100"
								}`}
							>
								Yes
							</label>
						</div>
					</div>
				</Form>
			</SetupDataPageTemplate>
		</>
	);
}
